import React from "react";
import classnames from "classnames";
import { getVariantLabel } from "@leafly-com/web-utils";
import currencyFormatter, {
  centsToDollars,
  bigDollarSmallCentsFormatter,
} from "common/currencyFormatter";
import fullVariantSizeText from "common/fullVariantSizeText";
import { DiscountTag } from "components/Dispensary/DiscountTag";

export function VariantTile({
  className,
  countryCode,
  selected = false,
  variant,
  ...props
}: any) {
  const { deal, price, unit, quantity } = variant;

  const dealActive = deal?.active;
  const displayPrice = dealActive
    ? centsToDollars(deal.discountedPrice)
    : price;
  const displayUnit = fullVariantSizeText(
    getVariantLabel({
      packageUnit: unit,
      packageSize: quantity,
    })
  );
  const [dollars, cents] =
    bigDollarSmallCentsFormatter(displayPrice, countryCode) || [];

  return (
    <div
      data-testid="variant-select__card"
      className={classnames(
        "relative h-full flex flex-col justify-end border rounded py-sm px-lg",
        {
          "border-light-grey": !selected,
          "bg-green-20 border-deep-green-60": selected,
        },
        className
      )}
      {...props}
    >
      {dealActive && (
        <DiscountTag
          className="top-0 right-0"
          discountAmount={deal.discountAmount}
          discountType={deal.discountType}
          side="right"
          isRounded={true}
        />
      )}

      {dealActive && (
        <div className="line-through text-xs">
          {currencyFormatter(price, countryCode)}
        </div>
      )}

      <div
        data-testid="variant-select__price"
        className="flex items-start font-bold text-base"
      >
        <span>$</span>
        <span className="text-hero leading-none font-headers">{dollars}</span>
        <span>{cents}</span>
      </div>

      <span className="font-bold text-xs mt-xs">{displayUnit}</span>
    </div>
  );
}
